import { FEATURE_CARDS as SHARED_FEATURE_CARDS } from '@repo/studio-components-feature-cards/feature-cards'
import type { FeatureCardData } from '@repo/studio-components-feature-cards/feature-cards'

export interface FeatureCard extends FeatureCardData {
  studioPath: string
}

const PATH_MAP: Record<string, string> = {
  image_editor: '/ai-image-editor',
  video_generator: '/ai-video-generator',
  nanobanana_2: '/flow',
  music_generator: '/ai-music-generator',
  logo_generator: '/logo-creator',
  seedream_2: '/ai-video-generator?model=seedance_two_point_zero',
  lyria_3: '/ai-music-generator',
}

export const FEATURE_CARDS: FeatureCard[] = SHARED_FEATURE_CARDS.map(card => ({
  ...card,
  studioPath: PATH_MAP[card.id] ?? '',
}))

const VIDEO_GENERATOR_ID = 'video_generator'

/** GROW-3276 variant order. Hoisting by id (rather than swapping indices 0 and 1) keeps this
 * correct if the shared card list is reordered upstream, and leaves every other card's
 * relative position untouched — so the Image Editor lands in second place on its own. */
export const VIDEO_GENERATOR_FIRST_FEATURE_CARDS: FeatureCard[] = [
  ...FEATURE_CARDS.filter(card => card.id === VIDEO_GENERATOR_ID),
  ...FEATURE_CARDS.filter(card => card.id !== VIDEO_GENERATOR_ID),
]
